import { render, staticRenderFns } from "./OverseasBanksInfo.vue?vue&type=template&id=386bc61f&scoped=true&"
import script from "./OverseasBanksInfo.vue?vue&type=script&lang=js&"
export * from "./OverseasBanksInfo.vue?vue&type=script&lang=js&"
import style0 from "./OverseasBanksInfo.vue?vue&type=style&index=0&id=386bc61f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386bc61f",
  null
  
)

export default component.exports